import { useEffect, useState } from 'react';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  deleteDoc,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

export function useFavoritesPosts() {
  const { currentUser } = useAuth();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!currentUser) {
      setFavorites([]);
      return;
    }

    const fetchFavorites = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, 'favoritePosts'), where('userId', '==', currentUser.uid));
        const snapshot = await getDocs(q);
        const favoriteIds = snapshot.docs.map((doc) => doc.data().postId);
        setFavorites(favoriteIds);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching favorite posts:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFavorites();
  }, [currentUser]);

  const toggleFavorite = async (postId) => {
    if (!currentUser) {
      throw new Error('Vous devez être connecté pour ajouter aux favoris');
    }

    try {
      const favoriteRef = doc(db, 'favoritePosts', `${currentUser.uid}_${postId}`);
      const favoriteDoc = await getDoc(favoriteRef);

      if (favoriteDoc.exists()) {
        await deleteDoc(favoriteRef);
        setFavorites((prev) => prev.filter((id) => id !== postId));
      } else {
        await setDoc(favoriteRef, {
          userId: currentUser.uid,
          postId,
          createdAt: new Date(),
        });
        setFavorites((prev) => [...prev, postId]);
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error toggling favorite post:', error);
      throw error;
    }
  };

  const isFavorite = (postId) => {
    return favorites.includes(postId);
  };

  return { favorites, loading, toggleFavorite, isFavorite };
}

